import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`The `}<Globals name="env" mdxType="Globals" />{` tools are integrated with the OpenShift console`}</p>
    </PageDescription>
    <p>{`With the release of `}<strong parentName="p"><Globals name="ocp" mdxType="Globals" /></strong>{` it is now even easier for
developers to integrate the DevSecOps tools into the OpenShift console. The
common DevSecOps tools are integrated into the OpenShift console. This enables
easy access to all the common tools a developer needs.`}</p>
    <h3>{`Tools configured with OpenShift Console`}</h3>
    <p>{`When the `}<Globals name="shortName" mdxType="Globals" />{` was configured for your development
cluster. The administrator can now configure a set of short cut links to
common tools you often use as a developer.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "54.513888888888886%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABzElEQVQoz4WSTW/TQBCG/SOggFoV2rhxYjspRIiIIz3Ra4SEuLfNB/xM7vwBjomQiZ21115/rO28zG5qJwWhjjSasXf28bzjMc5PX+Kt4+Ks04Fpmhi4Lmy7D5ei4ziU29pVblkWrj5cYTKZ4NPnL/h4fY3L4RCj0QjvxmOMxu9h9JwB+oPXOHpxgrvZAr/WayyXS3iehzAMEccxkiRpXZCnaQpleZ7vzumZ+x78H99h2O4lLnoOnjw7xu18AZZxhFEExpgGbLdbHJpIBSI6V7Cqqtr32yJHtvwJwxm+Qbfv4unzY9zNvyKVdEmkkLLYFxO0AQcB152XZam9rmsNrlUNnRuWPWiBs8U3BJsAq9UK3u81eJyQxyQr0XmsZIcCnHMNybKs7XL30RrG+UUPpmW3wCSNwcINAsaxCTnFiEawj2xDMYxQFIWepeqyASozXnW66HT7+qfcTud6PlJK/M/iNNSSldS/YSoaZ6bVAm+mMzCSWJQ1eQVJsaxquryfoRCJ/qjq8KHc+w4boJI8JcmRkOAih8hLpEWJjLwiaGOZEPB9X6/LI8DdHjKajyyKf6Q2FyRBmtk93iGtjV4Bmk9TdFis40F+uKNN/gdJPtFzQwiHGQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "OpenShift Links",
        "title": "OpenShift Links",
        "src": "/ibm-cloudnative-journey/static/4c44d4c8dff5f05ce73a21bbdd7f06c1/3cbba/openshift-console-tools.png",
        "srcSet": ["/ibm-cloudnative-journey/static/4c44d4c8dff5f05ce73a21bbdd7f06c1/7fc1e/openshift-console-tools.png 288w", "/ibm-cloudnative-journey/static/4c44d4c8dff5f05ce73a21bbdd7f06c1/a5df1/openshift-console-tools.png 576w", "/ibm-cloudnative-journey/static/4c44d4c8dff5f05ce73a21bbdd7f06c1/3cbba/openshift-console-tools.png 1152w", "/ibm-cloudnative-journey/static/4c44d4c8dff5f05ce73a21bbdd7f06c1/0f117/openshift-console-tools.png 1593w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`You can see how these tools are confgured by reading the `}<a parentName="p" {...{
        "href": "https://cloudnativetoolkit.dev/admin/config-install#optional-tool-configuration"
      }}>{`Tools configuration
`}</a></p>
    <h3>{`Opening the Dashboard`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Open a terminal`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Make sure you are logged into your Development cluster in a terminal.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`To do so, navigate to your cluster in the `}<em parentName="p">{`IBM Cloud Console`}</em>{`, click on the `}<strong parentName="p">{`Access`}</strong>{` tab and
follow the instructions to login from the command line`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`You can open the Dashboard from the enviornment you are configured with, use the `}<a parentName="p" {...{
            "href": "/ibm-cloudnative-journey/getting-started/cli#dashboard"
          }}>{`IGC CLI`}</a>{`.`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`igc dashboard
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`This will open the Dashboard`}</p>
      </li>
    </ul>
    <h3>{`Access the tools URLs`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`To list the ingress endpoints for all of the installed tools, use the `}<a parentName="p" {...{
            "href": "../getting-started/cli"
          }}>{`Developer Tools CLI`}</a>{` to run the following command:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`igc endpoints -n tools
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`This will return the ingress URLs for all of the tools installed in the Developer Tools cluster.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`? Endpoints in the 'tools' namespace. Select an endpoint to launch the default browser or 'Exit'.

 1) Exit
 2) developer-dashboard - http://dashboard.garage-dev-ocp4-c-518489-0143c5dd31acd8e030a1d6e0ab1380e3-0000.us-east.containers.appdomain.cloud
 3) argocd-server - https://argocd-tools.gsi-learning-ocp311-clu-7ec5d722a0ab3f463fdc90eeb94dbc70-0001.eu-gb.containers.appdomain.cloud
 4) artifactory - https://artifactory-tools.gsi-learning-ocp311-clu-7ec5d722a0ab3f463fdc90eeb94dbc70-0001.eu-gb.containers.appdomain.cloud
 5) dashboard - https://dashboard-tools.gsi-learning-ocp311-clu-7ec5d722a0ab3f463fdc90eeb94dbc70-0001.eu-gb.containers.appdomain.cloud
 6) developer-dashboard - http://dashboard.garage-dev-ocp4-c-518489-0143c5dd31acd8e030a1d6e0ab1380e3-0000.us-east.containers.appdomain.cloud
(Move up and down to reveal more choices)
 Answer:
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`You can then select the URL to open the tools’ dashboard directly.`}</p>
      </li>
    </ul>
    <h3>{`Credentials`}</h3>
    <p>{`In the future, the tools in the Dashboard will be linked using a single sign-on (SSO) service.
In the meantime, the CLI includes a command to list the tools’ logins.`}</p>
    <ul>
      <li parentName="ul">{`To list the logins for all of the installed tools, use the `}<a parentName="li" {...{
          "href": "../getting-started/cli"
        }}>{`Developer Tools CLI`}</a>{` to run the following command:`}<pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`igc credentials
`}</code></pre></li>
      <li parentName="ul">{`The command lists the `}<inlineCode parentName="li">{`userid`}</inlineCode>{` and `}<inlineCode parentName="li">{`password`}</inlineCode>{` for each tool installed. You can use these credentials to log into each of the installed tools.`}</li>
      <li parentName="ul">{`More of the tools in `}<Globals name="ocp" mdxType="Globals" />{` will be integrated into the
OpenShift console login process`}</li>
    </ul>
    <h3>{`Developer Dashboard`}</h3>
    <p>{`The Developer Dashboard is one of the tools running in your `}<Globals name="env" mdxType="Globals" />{`. It is designed to help you navigate to the installed tools and give you a simple way to perform common developer tasks, such as:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Dashboard`}</strong>{`: Navigate to the tools installed in the cluster`}</li>
      <li parentName="ul"><strong parentName="li">{`Activation`}</strong>{`: Links to education to help you learn cloud-native development and deployment using IBM Cloud Kubernetes Service and Red Hat OpenShift on IBM Cloud`}</li>
      <li parentName="ul"><strong parentName="li"><Globals name="templates" mdxType="Globals" /></strong>{`: Links to templates that will help accelerate your project`}</li>
    </ul>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "64.93055555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAAB9klEQVQ4y2VTy46bQBDkN3NNTrFgbdk/kEP+apV7TnuKlFiWtdr1GjBvGAaGZ6V7BjBORiqGaXq6q7oba7fb4XA4wHEcbDYbbLdbjf1+v7zbtv0A9nWm3bYdPDlf8enLN3y2v8MqyxJRFCFNU8RxDCEEeI3juGC9+FyrFl0PtF2HjkBGZEVJ5x5WVVVgDMOAvu+1Q9M0Gvw+23ifwQFV06NpW/3NoKVvHSy+WBArZiqlNKAEJe3suGY5JyVKGvzkM9vHib3VKIXr2xuilVxFwUL/pktgAgBJkuiymCTmckalkkREy56WJa5XfDz/wECHjiTwdfX+AXV+1bZhCng8HuG6rn6fpbd/fmJU0rCfbJphGkdUF7Vk4qw3z0dLCWa5RZHD81ytgiXySuNQ+66baHWVgrwlKyMgqhypiKe6mYC/fnsIQ7nYhnFA+xpQq/ulvgyLZUZBSE0oTb3ovqwr5MRI1XfWeVYizwUUKdGXKaCgGnOdZyUmYD+gkGZsZnl5GFKAzGSebLEoUdNErOfxEggqhXiYWYvpS9kQSp29p8BNXaMm8Hzq7GQTVKuEulzkuZ7Rnog09+beJcs6w/n9BTXVch4R3/dxOp0WJ15BLOB6ASJifx+T//8mq24LRMX5oVM8b5fLZTXMHarGjPPsp+fxn1+U8Rd6KdZUNGrrdgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Developer Dashboard",
        "title": "Developer Dashboard",
        "src": "/ibm-cloudnative-journey/static/7e07b99cac9c5058f7955f4ee7beec62/3cbba/developer-dashboard.png",
        "srcSet": ["/ibm-cloudnative-journey/static/7e07b99cac9c5058f7955f4ee7beec62/7fc1e/developer-dashboard.png 288w", "/ibm-cloudnative-journey/static/7e07b99cac9c5058f7955f4ee7beec62/a5df1/developer-dashboard.png 576w", "/ibm-cloudnative-journey/static/7e07b99cac9c5058f7955f4ee7beec62/3cbba/developer-dashboard.png 1152w", "/ibm-cloudnative-journey/static/7e07b99cac9c5058f7955f4ee7beec62/5bc80/developer-dashboard.png 1442w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      